import { BreakpointsOptions } from '@mui/system';

export const breakpoints: BreakpointsOptions = {
  values: {
    xxs: 0,
    xs: 375,
    sm: 412,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1366,
    xxxl: 1920,
  },
};
